import { css } from '@emotion/core';
import React from 'react';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import { requestStaticContent } from '@/src/cms/utils';

function WhyJoin(props) {
  return (
    <ContentPage
      {...props}
      bodyStyle={css`
        .sanitized {
          @media (max-width: 595px) {
            div {
              width: 100% !important;
              flex-direction: column;
            }
            table {
              width: 100% !important;
            }
          }
          &::after {
            clear: both;
            content: '';
            display: table;
          }
        }
      `}
    />
  );
}

export async function getStaticProps() {
  const sitepageid = 55497;
  const pagedata = await requestStaticContent(sitepageid);
  return { props: { sitepageid, pagedata } };
}

export default WhyJoin;
